import { Sizes } from 'enums/sizes';
import { usePanel } from 'hooks/usePanel';
import { useCallback, useState } from 'react';
import { ProductForm } from './form/ProductForm';
import ProduitsAdminList from './ProduitsAdminList';

/**
 * Écran admin des produits : la nouvelle liste générique (facettes/tri/colonnes) en
 * conservant l'action « Créer un nouveau produit » (formulaire existant).
 */
export default function ProduitsAdminScreen() {
  const { openPanel } = usePanel();
  // Bump pour refetch la liste dès qu'un produit vient d'être créé
  const [refreshToken, setRefreshToken] = useState(0);

  const openAddProductForm = useCallback(() => {
    openPanel(
      { title: 'Ajouter un produit', size: Sizes['4xl'] },
      <ProductForm onSuccess={() => setRefreshToken(token => token + 1)} />
    );
  }, [openPanel]);

  return (
    <ProduitsAdminList
      refreshToken={refreshToken}
      createConfig={{ label: 'Créer un nouveau produit', onClick: openAddProductForm }}
    />
  );
}
